import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Message } from 'semantic-ui-react';
// import { getLocalStorageWithExpiry /*, log */ } from '@emyw/core-lib';
import Step1PlansMatrix from '@emyw/subscribe-lib/Step1PlansMatrix';
import { withAppContext } from '../AppContext';
import { loadUser } from '../actions/userActions';
import { ValidateStep, wizardPageSequence, subscriptionProgress } from './index';

const { REACT_APP_FREE_PLAN_CODE: FREE /* , REACT_APP_PREMIUM_PLAN_CODE: PREMIUM */ } = process.env;

class SelectPlan extends Component {
    state = {
        proceedTo: undefined,
        error: undefined,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user);
        context.setAppState({ currentStep: 'plan' });
    }

    setNextLocation = (pathname) => {
        localStorage.setItem('enjoy-signup-progress', pathname);
        this.setState({ proceedTo: pathname });
    }

    handleContinueClick = (planName) => {
        const { context } = this.props;
        const { user: stateUser, disableSocialLogin } = context.state;

        if (stateUser && !stateUser.signupCompletedOn) {
            // Reload user with new plan
            (loadUser('network-only'))(({ user }) => {
                context.setAppState({ user });
                if (planName === FREE) {
                    // this.setNextLocation('signupcomplete');
                    this.setState({ proceedTo: 'confirm' });
                } else {
                    const progress = subscriptionProgress(user);
                    if (wizardPageSequence[progress].index > wizardPageSequence.payment.index) {
                        // this.setNextLocation(progress);
                        this.setState({ proceedTo: progress });
                    } else {
                        // this.setNextLocation('payment');
                        this.setState({ proceedTo: 'payment' });
                    }
                }
            });
        } else {
            localStorage.setItem('plan-code', planName);
            if (subscriptionProgress(stateUser) === 'verifyaccount') {
                this.setState({ proceedTo: 'verifyaccount' });
            } else {
                this.setNextLocation(disableSocialLogin ? 'newaccount' : 'setupaccount');
            }
        }
    };

    handleTermsClick = () => {
        // alert('terms');
        const { context } = this.props;
        context.setAppState({ termsModalOpen: true });
    }

    render() {
        const { context } = this.props;
        const { proceedTo } = this.state;
        if (proceedTo) return <Redirect push to={`/signup/${proceedTo}`} />;

        let { user } = context.state;
        // eslint-disable-next-line no-unused-vars
        const { skipPlanSelect, planSettings, disableSocialLogin } = context.state;
        // eslint-disable-next-line no-unused-vars
        const nextStep = disableSocialLogin ? 'newaccount' : 'setupaccount';
        if (skipPlanSelect) {
            if (localStorage.getItem('enjoy-signup-progress') === 'plan') {
                localStorage.setItem('enjoy-signup-progress', disableSocialLogin ? 'newaccount' : 'setupaccount');
            }
            return <Redirect to={`/signup/${nextStep}`} />;
        }
        const { freeSignupDisabled } = planSettings;
        // log.trace('SelectPlan user:', user);
        if (user && Object.keys(user).length === 0) user = undefined;
        const { error } = this.state;
        const { userId } = (user || {});
        const selectedPlanCode = user && !user.signupCompletedOn
            ? user.subscriptionLevelCode
            : localStorage.getItem('plan-code');
            // (getLocalStorageWithExpiry('enjoy-promo-code')
            //     ? PREMIUM
            //     : localStorage.getItem('plan-code'));

        return (
            <div style={{ margin: '0 auto', maxWidth: '1000px' }}>
                <Helmet>
                    <title>Enjoy Signup - Select Plan</title>
                    <meta name="description" content="Select plan" />
                </Helmet>
                <Step1PlansMatrix
                    planCode={selectedPlanCode}
                    onTermsClick={this.handleTermsClick}
                    onContinueClick={this.handleContinueClick}
                    user={user || {}}
                    userId={userId}
                    hideFreePlan={freeSignupDisabled}
                    darkMode
                />
                {error ? (
                    <Message
                        size="small"
                        error
                        header="Trouble with setting plan..."
                        content={error}
                    />
                ) : null}
            </div>
        );
    }
}

export default withAppContext(SelectPlan);
